
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				<el-form-item  style="float:right;">
					<el-button type="primary" @click="handleAdd">添加赛事</el-button>
				</el-form-item>					
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getListData" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getListData" placeholder="赛事名称"></el-input>
				</el-form-item>
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="List" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">	
    <el-table-column type="expand">
      <template slot-scope="props">
          <el-table :data="props.row.CompetitionGroup">
          <el-table-column prop="Name" label="组名" width="120"  sortable>             
          </el-table-column>
			<el-table-column prop="Type" label="组类型" width="100" :formatter="formatType" sortable>
			</el-table-column> 
			<el-table-column prop="ItemCount" label="项目数量" width="120" sortable>
			</el-table-column> 			         
           	<el-table-column prop="Sex" label="性别" width="100" :formatter="formatSex"  sortable>
			</el-table-column>	           
           	<el-table-column prop="StartTime" label="最小参赛生日" width="140"  sortable>
			</el-table-column>
           	<el-table-column prop="EndTime" label="最大参赛生日" width="140"  sortable>
			</el-table-column>			
 			  <el-table-column prop="State" label="状态" width="100" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.State=='1'">已锁定</el-tag>
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='0'||scope.row.State==null">未锁定</el-tag>
                  </div>
                  </template>
			</el-table-column>  			
			<el-table-column prop="Remark" label="备注"width="180" sortable>
				
			</el-table-column>
			<el-table-column  label="操作" min-width="150" fixed="right"  sortable>
					<template slot-scope="scope" >
					<el-button type="primary" size="small" @click="handleShowItems(scope.row)">项目管理</el-button>					

					<el-button size="small" @click="handleGroupEdit( scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleGroupDel(scope.$index, scope.row)">删除</el-button>

						
                    </template> 
			</el-table-column>             
          </el-table>
      </template>
    </el-table-column>  
			<el-table-column prop="CompetitionTypeName" label="赛事分类" width="120" sortable>
			</el-table-column>            
			<el-table-column prop="Name" label="赛事名称" width="240" sortable>
			</el-table-column>
  			  <el-table-column prop="CompetitionState" label="赛事状态" width="120" >				  
				<template slot-scope="scope">			
				     <el-dropdown trigger="click">
                      <el-tag type="info"  v-if="scope.row.CompetitionState==0" size="small" >新增</el-tag>
                      <el-tag type="warning"  v-else-if="scope.row.CompetitionState==1" size="small" >准备</el-tag>
					   <el-tag type="primary"   v-else-if="scope.row.CompetitionState==2" size="small" >发布</el-tag>
					  <el-tag type="success"   v-else-if="scope.row.CompetitionState==3" size="small" >报名</el-tag>
					  <el-tag type="success"   v-else-if="scope.row.CompetitionState==4" size="small" >报名结束</el-tag>
					  <el-tag type="danger"   v-else-if="scope.row.CompetitionState==5" size="small" >比赛</el-tag>
					  <el-tag type="danger"   v-else-if="scope.row.CompetitionState==6" size="small" >比赛结束</el-tag>
					  <el-tag type="blue"   v-else-if="scope.row.CompetitionState==7" size="small" >赛事完结</el-tag>

                     <el-dropdown-menu slot="dropdown" >
                         <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,0)" >
                            新增
                          </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,1)">
                            准备
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,2)">
                            发布
                         </el-dropdown-item>	
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,3)">
                            报名中
                         </el-dropdown-item>	
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,4)">
                            报名结束
                         </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,5)">
                            比赛中
                         </el-dropdown-item>	
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,6)">
                            比赛结束
                         </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,7)">
                            赛事完结
                         </el-dropdown-item>						 						 					 						 				 					 
                     </el-dropdown-menu>
                     </el-dropdown>				
					 	 </template>
			</el-table-column>                      
 			<el-table-column prop="GroupCount" label="组数" width="100" sortable>
			</el-table-column>	
 			<el-table-column prop="Number" label="队伍可报人数" width="145" sortable>
			</el-table-column>				
 			<el-table-column prop="ContactName" label="联系人" width="100" sortable>
			</el-table-column>	
 			<el-table-column prop="ContactNumber" label="号码" width="125" sortable>
			</el-table-column>								  
			<el-table-column prop="RegistrationStart" label="报名开始时间" width="150" :formatter="formatDate"  sortable>
			</el-table-column>
			<el-table-column prop="RegistrationEnd" label="报名结束时间" width="150" :formatter="formatDate"  sortable>
			</el-table-column>
			<!-- <el-table-column prop="IDnumber" label="报名剩余时间" width="150"  sortable>
			</el-table-column> -->
			<el-table-column prop="StartTime" label="比赛开始时间" width="150" :formatter="formatDate"   sortable>
			</el-table-column>
 			<el-table-column prop="EndTime" label="比赛结束时间" width="150" :formatter="formatDate"  sortable>
			</el-table-column>   
  			<el-table-column prop="Addres" label="举办地点" width="240"  sortable>
			</el-table-column>                    
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<!-- <el-table-column  label="变更状态" width="150" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="List[scope.$index].Id"   v-model="List[scope.$index].State==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="Change(scope.row,List[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>	             -->
			<el-table-column label="操作" min-width="480" fixed="right">
				<template  slot-scope="scope">
					<el-button type="primary" size="small" @click="handleGroupAdd(scope.row)">新增组</el-button>
					<el-button type="warning" size="small" @click="handleShowEntry(scope.row)">报名信息</el-button>	
					 <el-button size="small" type="primary" @click="achievementmanage(scope.row)">成绩管理</el-button>									
                     <el-button type="primary" size="small"  @click="ShowExport(scope.row)" >导出管理</el-button>
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}个赛事</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
        <el-dialog id="tt" title="成绩上传" v-model="uploadFileVisible" >
             <el-upload
              class="upload-demo"
              drag action=""
              :http-request="upload"
              multiple customClass=".el-upload-dragger">
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">上传PDF成绩文件</div>
            </el-upload>
		</el-dialog>

		<el-dialog title="成绩管理" v-model="achievementmanageVisivle" :close-on-click-modal="false">
					<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form    style="float: right;">
				<el-form-item>
					<el-button type="primary" @click="uploadPDF">上传成绩pdf</el-button>
				</el-form-item>						
			</el-form>
		</el-col>
           <el-table :data="achienementList" highlight-current-row >
			   <el-table-column  prop="FileName" label="文件名" min-width="180"  >                  
				</el-table-column>	
			   <el-table-column  prop="CreationTime" label="添加时间" min-width="180"  >                  
				</el-table-column>																					
			<el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">					
					<el-button type="primary" size="small" @click="FileDown(scope.row)">下载成绩单</el-button>
					<el-button type="danger" size="small" @click="FileDel(scope.$index, scope.row)">删除</el-button>
				</template>


			</el-table-column>							
		   </el-table>
		</el-dialog>

		<el-dialog title="下载报表管理" v-model="exportVisivle" :close-on-click-modal="false">
 			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form    style="float: right;">
				<el-form-item>
					<el-button type="primary" @click="ExportReport()">报名表</el-button>
					<el-button type="primary" @click="WordFileDown()">代表队人数统计</el-button>
					<el-button type="primary" @click="RosterFileDown()">代表队名单</el-button>

				</el-form-item>										
			</el-form>
		   </el-col>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
				<el-form-item label="赛事分类" prop="CompetitionTypeId">
                  <el-select v-model="editForm.CompetitionTypeId"  clearable placeholder="请选择赛事分类" style="width:100%">
                <el-option 
                     v-for="item in options"
                     :key="item.Id"
                     :label="item.Name"
                     :value="item.Id">
               </el-option>                                                                             
                 </el-select>				
                 </el-form-item>

				<el-form-item label="赛事名称" prop="Name">
					<el-input v-model="editForm.Name" auto-complete="off"></el-input>
				</el-form-item>	                
 				<!-- <el-form-item label="赛事组数" prop="GroupCount">
					<el-input v-model.number="editForm.GroupCount" auto-complete="off"></el-input>
				</el-form-item>  -->
 				<el-form-item label="赛事联系人" prop="ContactName">
					<el-input v-model="editForm.ContactName" auto-complete="off"></el-input>
				</el-form-item> 
 				<el-form-item label="联系号码" prop="ContactNumber">
					<el-input v-model="editForm.ContactNumber" auto-complete="off"></el-input>
				</el-form-item> 
 				<el-form-item label="队伍可报人数" prop="Number">
					<el-input v-model="editForm.Number" auto-complete="off"></el-input>
				</el-form-item> 				
				<el-form-item label="报名开始时间" prop="RegistrationStart">
					<el-date-picker  v-model="editForm.RegistrationStart"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>	
				<el-form-item label="报名结束时间" prop="RegistrationEnd">
					<el-date-picker  v-model="editForm.RegistrationEnd"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>	
				<el-form-item label="比赛开始时间" prop="StartTime">
					<el-date-picker  v-model="editForm.StartTime"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>	
				<el-form-item label="比赛结束时间" prop="EndTime">
					<el-date-picker  v-model="editForm.EndTime"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>																									              
				<!-- <el-form-item label="性别" prop="Sex">
					<el-input v-model="addForm.Sex" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="出生日期" prop="Birthday">
					<el-input v-model.number="addForm.Birthday" auto-complete="off"></el-input>
				</el-form-item>	 -->
 				<el-form-item label="举办地点" prop="Addres">
					<el-input v-model="editForm.Addres" auto-complete="off"></el-input>
				</el-form-item>		
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>	                                     
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item label="赛事分类" prop="CompetitionTypeId">
                  <el-select v-model="addForm.CompetitionTypeId"  clearable placeholder="请选择赛事分类" style="width:100%">
                <el-option 
                     v-for="item in options"
                     :key="item.Id"
                     :label="item.Name"
                     :value="item.Id">
               </el-option>                                                                             
                 </el-select>				
                 </el-form-item>

				<el-form-item label="赛事名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>	                
 				<!-- <el-form-item label="赛事组数" prop="GroupCount">
					<el-input v-model.number="addForm.GroupCount" auto-complete="off"></el-input>
				</el-form-item>  -->
 				<el-form-item label="赛事联系人" prop="ContactName">
					<el-input v-model="addForm.ContactName" auto-complete="off"></el-input>
				</el-form-item> 
 				<el-form-item label="联系号码" prop="ContactNumber">
					<el-input v-model="addForm.ContactNumber" auto-complete="off"></el-input>
				</el-form-item> 
 				<el-form-item label="队伍可报人数" prop="Number">
					<el-input v-model="addForm.Number" auto-complete="off"></el-input>
				</el-form-item> 				
				<el-form-item label="报名开始时间" prop="RegistrationStart">
					<el-date-picker  v-model="addForm.RegistrationStart"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>	
				<el-form-item label="报名结束时间" prop="RegistrationEnd">
					<el-date-picker  v-model="addForm.RegistrationEnd"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>	
				<el-form-item label="比赛开始时间" prop="StartTime">
					<el-date-picker  v-model="addForm.StartTime"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>	
				<el-form-item label="比赛结束时间" prop="EndTime">
					<el-date-picker  v-model="addForm.EndTime"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>																									              
				<!-- <el-form-item label="性别" prop="Sex">
					<el-input v-model="addForm.Sex" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="出生日期" prop="Birthday">
					<el-input v-model.number="addForm.Birthday" auto-complete="off"></el-input>
				</el-form-item>	 -->
 				<el-form-item label="举办地点" prop="Addres">
					<el-input v-model="addForm.Addres" auto-complete="off"></el-input>
				</el-form-item>	
                                               					
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
		<!-- 组相关 -->
		<el-dialog title="新增组" v-model="addGroupVisible" :close-on-click-modal="false">
			<el-form :model="addGroup" label-width="130px" :rules="addGroupRules" ref="GroupFrom">
				<el-form-item label="组类别" prop="Type">
					<el-radio-group v-model="addGroup.Type" >
						<el-radio class="radio" :label="1">团体项目</el-radio>
						<el-radio class="radio" :label="0">个人项目</el-radio>
					</el-radio-group>			
                 </el-form-item>

				<el-form-item label="组名称" prop="Name">
					<el-input v-model="addGroup.Name" auto-complete="off"></el-input>
				</el-form-item>	  
				<el-form-item label="性别">
					<el-radio-group v-model="addGroup.Sex" >
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
						<el-radio class="radio" :label="2">混合</el-radio>
					</el-radio-group>
				</el-form-item>	
				<el-form-item label="参赛出生日期">
                    <div class="block">
                   <el-date-picker
                        v-model="addGroup.dateValue"
                         type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="left">
                   </el-date-picker>
                    </div>
                </el-form-item>				
 				<!-- <el-form-item label="出生日期开始日期" prop="StartTime">
					<el-input-number v-model="addGroup.StartTime" auto-complete="off" style="width:100%"></el-input-number>
				</el-form-item> 
 				<el-form-item label="出生日期结束日期" prop="EndTime">
					<el-input-number v-model="addGroup.EndTime" auto-complete="off" style="width:100%"></el-input-number>
				</el-form-item>  -->

				<el-form-item label="备注">
					<el-input type="textarea" v-model="addGroup.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addGroupVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addGroupSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="编辑组" v-model="editGroupVisible" :close-on-click-modal="false">
			<el-form :model="editGroup" label-width="130px" :rules="editGroupRules" ref="editGroupFrom">
				<el-form-item label="组类别" prop="Type">
					<el-radio-group v-model="editGroup.Type" >
						<el-radio class="radio" :label="1">团体项目</el-radio>
						<el-radio class="radio" :label="0">个人项目</el-radio>
					</el-radio-group>			
                 </el-form-item>

				<el-form-item label="组名称" prop="Name">
					<el-input v-model="editGroup.Name" auto-complete="off"></el-input>
				</el-form-item>	  
				<el-form-item label="性别">
					<el-radio-group v-model="editGroup.Sex" >
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
						<el-radio class="radio" :label="2">混合</el-radio>
					</el-radio-group>
				</el-form-item>					
				<el-form-item label="参赛出生日期">
                    <div class="block">
                   <el-date-picker
                        v-model="editGroup.dateValue"
                         type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="left">
                   </el-date-picker>
                    </div>
                </el-form-item>		

				<el-form-item label="备注">
					<el-input type="textarea" v-model="editGroup.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editGroupVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editGroupSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>	
		<!-- 编辑项目 -->
		<el-dialog title="编辑项目" v-model="editItemsVisible" :close-on-click-modal="false">
			<el-form :model="editItems" label-width="120px" :rules="editItemsRules" ref="editItems">
				<el-form-item label="项目泳姿" prop="CompetitionPostureId">
                  <el-select filterable v-model="editItems.CompetitionPostureId"  clearable placeholder="请选择泳姿"  @change="selectChange($event,'edit')" style="width:100%">
                <el-option 
                     v-for="item in postureOption"
                     :key="item.Id"
                     :label="item.Name+' '+item.Distance"
                     :value="item.Id">
               </el-option>                                                                             
                 </el-select>				
                 </el-form-item>

				<el-form-item label="项目名称" prop="Name">
					<el-input v-model="editItems.Name" auto-complete="off"></el-input>
				</el-form-item>	  
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editItems.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editItemsVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editItemSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="新增项目" v-model="addItemsVisible" :close-on-click-modal="false">
			<el-form :model="addItems" label-width="120px" :rules="addItemsRules" ref="addItems">
				<el-form-item label="项目泳姿" prop="CompetitionPostureId">
                  <el-select filterable v-model="addItems.CompetitionPostureId"  clearable placeholder="请选择泳姿" @change="selectChange($event,'add')" style="width:100%">
                <el-option 
                     v-for="item in postureOption"
                     :key="item.Id"
                     :label="item.Name+' '+item.Distance"
                     :value="item.Id">
               </el-option>                                                                             
                 </el-select>				
                 </el-form-item>

				<el-form-item label="项目名称" prop="Name">
					<el-input v-model="addItems.Name" auto-complete="off"></el-input>
				</el-form-item>	  
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addItems.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addItemsVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addItemSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!-- 比赛项目 -->
		<el-dialog :title="GroupItemNameTitle" v-model="groupItemsVisible" :close-on-click-modal="false">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form    style="float: right;">
				<el-form-item>
					<el-button type="primary" @click="addItem">新增项目</el-button>
				</el-form-item>						
			</el-form>
		    </el-col> 
            <el-table :data="groupItemsTable" highlight-current-row v-loading="listLoading">	
			<el-table-column prop="Name" label="项目名称" width="150" sortable>
			</el-table-column>
			<el-table-column prop="CompetitionPostureName" label="泳姿名称" width="120" sortable>
			</el-table-column>				
			<el-table-column prop="Distance" label="距离" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
		    <el-table-column prop="State" label="项目状态"  width="120" sortable fixed="right">  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.State=='1'">已锁定</el-tag>
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='0'||scope.row.State==null">未锁定</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column label="操作" width="140" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="handleItemEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleItemDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>				  
            </el-table>
		   	<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-tag>共有{{groupItemsCount}}个比赛项目</el-tag>
	     	</el-col>			
		</el-dialog>
        <el-dialog title="报名人员" v-model="peopleVisible" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >            
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>							
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getEntry" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.PeopleName"   placeholder="人员名称"></el-input>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.TeamName"   placeholder="单位名称"></el-input>
				</el-form-item>	
                <el-form-item>					
                <el-select  v-model="filters.GroupType" clearable filterable placeholder="选择组类型"  >
                 <el-option label="普通" value="0"> </el-option>
                 <el-option label="接力组" value="1"></el-option>                			 
                   </el-select>	
				</el-form-item>									
			</el-form>
           </el-col>
		<el-table  :data="PeopleList" highlight-current-row v-loading="Loading">	
			<el-table-column prop="CompetitionTeamName" label="单位" width="120" sortable>
			</el-table-column>      
			<el-table-column prop="IdentityName" label="身份" width="120" sortable>
			</el-table-column>  							
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>         
 			<el-table-column prop="Sex" label="性别" width="100"  :formatter="formatSex" sortable>
			</el-table-column>
			<el-table-column prop="IDNumber" label="证件号" width="180"  sortable>
			</el-table-column>				           
			<el-table-column prop="Coache" label="教练" width="100"  sortable>
			</el-table-column>
			<el-table-column prop="CompetitionPostureName" label="泳式" width="150"  sortable>
			</el-table-column>			
			<el-table-column prop="Birthday" label="出生日期" min-width="180" :formatter="formatEntryDate"  sortable>
			</el-table-column>						
		</el-table>
		<el-col :span="24" class="toolbar">
			<el-tag>当前共{{PeopleCount}}条报名信息</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange1" :page-size="10" :total="PeopleCount" style="float:right;">
			</el-pagination>
		</el-col> 
		</el-dialog>

		
  <!-- 重置界面 -->
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import {DownRoster,DownSumWord,DownFile,UploadFile,DeleteCompetitionFile,CompetitionFileList,ExportEntryReport,EntryList, editGroupItem,removeGroupItem,addGroupItem,getCompetitionPostureList,getGroupItemList,removeCompetitionGroup,getCompetitionGroupList,editCompetitionGroup, addCompetitionGroup,getCompetitionTypeList, CompetitionList, removeCompetition, addCompetition,editCompetition ,ChangeCompetitionState } from '../../api/api';

	export default {
		data() {
			return {
				exportCurrentRow:{},
				exportVisivle:false,
				TenancyId:0,
				CompetitionId:0,
				uploadFileVisible:false,
				achienementList:[],
				achievementmanageVisivle:false,
				GroupItemNameTitle:"",
				//报名
				Loading:false,
				PeopleCount:0,
				Peoplepage:0,
				PeopleList:[],
				peopleVisible:false,
				PeopleCompetitionId:'',
				SelectGroupName:'',
// 比赛项目
			   
			   editItemsVisible:false,
			   editItemsRules:{
					Name: [
						{ required: true, message: '请输入项目名称', trigger: 'blur' }
                    ],	
       				CompetitionPostureId: [
                        {  required: true, message: '请选择泳姿', trigger: 'blur' }
                    ],                       					   
			   },  
			   editItems:{},			   
			   addItemsVisible:false,
			   addItemsRules:{
					Name: [
						{ required: true, message: '请输入项目名称', trigger: 'blur' }
                    ],	
       				CompetitionPostureId: [
                        {  required: true, message: '请选择泳姿', trigger: 'blur' }
                    ],                       					   
			   },  
			   addItems:{
					CompetitionId:'',
					CompetitionName:'',
					CompetitionGroupId:'',
					CompetitionGroupName:'',
					Name:'',
					CompetitionPostureId:'',
					CompetitionPostureName:'',
                    Remark:''
				},
                postureOption:[],
                groupItemsCount:0,
				groupItemsVisible:false,
				groupItemsTable:[],

				currentRow:{},
				currentGroupRow:{},
				
                editGroupRules:{},
				editGroupVisible:false,
                editGroup:{

				 },	

                addGroupRules:{},
				addGroupVisible:false,
                addGroup:{
					Type:0,
					Name:'',
					Sex:0,
					AgeMin:0,
					AgeMax:0,
					StartTime:'',
					EndTime:'',
					Remark:'',
					dateValue:''
				},
                options:[                                                                                 
                ],
				filters: {
					Name: '',
					Type:'',	
					PeopleName:'',
					GroupType:'',
					TeamName:''			
				},
				fit:'contain',
				coachId:'',
				Count:0,
				List:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					Name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
                    ],	
                    		
 					// GroupCount: [
                    //     { required: true, message: '请输入组数'},
                    //     { type: 'number', message: '必须为数字值'}
                    // ],     
 
                    
                    
    				RegistrationStart: [			
                        { type: 'date',  required: true, message: '请选择报名开始时间', trigger: 'change' }
                    ],                     
    				RegistrationEnd: [
                        { type: 'date',  required: true, message: '请选择报名结束时间', trigger: 'change' }
                    ],                     
     				StartTime: [
                        {   type: 'date',required: true, message: '请选择比赛开始时间', trigger: 'change' }
					],
					EndTime: [
                        {   type: 'date',required: true, message: '请选择比赛结束时间', trigger: 'change' }
					],   
					Addres: [
                        {   required: true, message: '请输入举报地点', trigger: 'blur' }
                    ],                                       
				},
				//编辑界面数据
				editForm: {
					id: 0,
					Name: '',
					CompetitionTypeId:'',
					Addres:'',
					RegistrationStart:'',
					RegistrationEnd:'',
					StartTime:'',
					EndTime:'',
					Number:'',
					ContactName:'',
					ContactNumber:'',
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
                    ],	
                    		
 					// GroupCount: [
                    //     { required: true, message: '请输入组数'},
                    //     { type: 'number', message: '必须为数字值'}
                    // ],     
 
                    
			    	RegistrationStart: [			
                        { type: 'date',  required: true, message: '请选择报名开始时间', trigger: 'change' }
                    ],                     
    				RegistrationEnd: [
                        { type: 'date',  required: true, message: '请选择报名结束时间', trigger: 'change' }
                    ],                     
     				StartTime: [
                        {   type: 'date',required: true, message: '请选择比赛开始时间', trigger: 'change' }
					],
					EndTime: [
                        {   type: 'date',required: true, message: '请选择比赛结束时间', trigger: 'change' }
					], 
					Addres: [
                        {  required: true, message: '请输入举报地点', trigger: 'blur' }
                    ],  					                  
                                                                       
                    
				},
				//新增界面数据
				addForm: {
					Name: '',
					CompetitionTypeId:'',
					Addres:'',
					RegistrationStart:'',
					RegistrationEnd:'',
					StartTime:'',
					EndTime:'',
					GroupCount:0,
					ContactName:'',
					ContactNumber:'',
					Number:'0'
				}
			}
		},
		methods: {
			ShowExport(row)
			{
			   this.exportVisivle=true;
			   this.exportCurrentRow=row;
			   
			},
			RosterFileDown(){
				let para={
					CompetitionId:this.exportCurrentRow.Id,
				}				

				DownRoster(para).then((res)=>{
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = this.exportCurrentRow.Name+'-代表队名单'; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
					 }					
				}).catch(error=>{					
                 alert('网络错误');
                });  
			},
			WordFileDown()
			{
				let para={
					CompetitionId:this.exportCurrentRow.Id,
				}				
				DownSumWord(para).then((res)=>{
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = this.exportCurrentRow.Name+'-代表队人数统计'; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
					 }					
				}).catch(error=>{					
                 alert('网络错误');
                });  
			},
			FileDown(row){
				let para={
					id:row.Id,
				}
				// console.log(para);
				DownFile(para).then((res)=>{
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/pdf"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = row.FileName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
					 }					
				}).catch(error=>{					
                 alert('网络错误');
                });                
			},
			uploadPDF(){
				this.uploadFileVisible=true;
			},
			upload(param)
			{
			    var fileObj=param.file;
				var fd=new FormData();
				fd.append("file",fileObj);
				fd.append("CompetitionId",this.CompetitionId)
			  	UploadFile(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.FileList(this.CompetitionId);
						// this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
		              
			  }).catch(error=>{
                 alert('网络错误');
                });
			},			
		FileList(value)
			{
				let para={
					CompetitionId:value,
				}
				// console.log(para);
				CompetitionFileList(para).then((res)=>{
					console.log(res);
                  this.achienementList=res.data.Data;
				}).catch(error=>{					
                 alert('网络错误');
                });
			},
			FileDel(index,row){
				let para={
					id:row.Id
				}
				 
				 DeleteCompetitionFile(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						let newarr=[];
						for(var i=0;i< this.achienementList.length;i++){
							if(this.achienementList[i].Id===row.Id)
							{

							}
							else
							{
                                newarr.push(this.achienementList[i]);
							}
							
						}
						this.achienementList=[];
						this.achienementList=newarr;
						// this.getMember();
						}
						else{
						this.$message({
							message: '删除失败',
							type: 'error'
						});
						}

				}).catch(error=>{					
                 alert('网络错误');
                });
			},			
			achievementmanage(row){
				this.achievementmanageVisivle=true;
				this.TenancyId=row.TenancyId;
				this.CompetitionId=row.Id;
				this.FileList(row.Id);
			},
        selectChange(event,flag)
        { 
			console.log(event);
			let obj ={}
           obj = this.postureOption.find((item)=>{
           return item.Id === event;
            });
		this.SelectGroupName=obj.Name+obj.Distance+'米';
		if(flag==='add')
		{
           this.addItems.Name=this.SelectGroupName;
		}
		if(flag==='edit')
		{
          this.editItems.Name=this.SelectGroupName;
		}
        },			
	    ExportReport(){
					   let para={
			   CompetitionId:this.exportCurrentRow.Id
		   }
		   ExportEntryReport(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = '报名表'; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })		   			
		},			
			getEntry(){
				let para={
					PageIndex: this.Peoplepage-1,					
					PageSize:10,	
				CompetitionGroupType:this.filters.GroupType,
				CompetitionTeamName:this.filters.TeamName,
				Name:this.filters.PeopleName,
				CompetitionId:this.PeopleCompetitionId
				}
				this.Loading = true;
                  EntryList(para).then((res)=>{
					  this.Loading = false;
				   this.PeopleList=res.data.Data;
					this.PeopleCount= res.data.TotleCount;					
					//NProgress.done();				   
				    }).catch(error=>{
				   })			   
			},
			handleShowEntry(row){
			   this.peopleVisible=true;
			   this.PeopleCompetitionId=row.Id;
              this.getEntry();
			},
			addItem(){
				this.addItemsVisible=true;
				this.addItems={
					CompetitionId:'',
					CompetitionName:'',
					CompetitionGroupId:'',
					CompetitionGroupName:'',
					Name:'',
					CompetitionPostureId:'',
					CompetitionPostureName:'',
                    Remark:''
				}
				this.addItems.CompetitionId=this.currentGroupRow.CompetitionId;
				this.addItems.CompetitionName=this.currentGroupRow.CompetitionName;
				this.addItems.CompetitionGroupId=this.currentGroupRow.Id;
				this.addItems.CompetitionGroupName=this.currentGroupRow.Name;
               this.GetPostureOption();
			},
			GetPostureOption(){
				let para={State:0}
                  getCompetitionPostureList(para).then((res)=>{
				   this.postureOption=res.data;
				    }).catch(error=>{
				   })					   				   
			}, 
			groupItemsData(){
                 let para={
					 CompetitionGroupId: this.currentGroupRow.Id
				 }
                  getGroupItemList(para).then((res)=>{
				    //  this.List.forEach(element => {
					// 	 if(element.Id==value)
					// 	 {
					// 		element.CompetitionGroup=res.data;
					// 	 }
					//  });
					this.groupItemsTable=res.data;
					this.groupItemsCount=res.data.length;
				    }).catch(error=>{
				   })					 
			},
		handleShowItems(row){
			  this.currentGroupRow=row;
			  this.groupItemsVisible=true;
			  this.GroupItemNameTitle="";
			  this.GroupItemNameTitle="比赛项目管理-"+row.Name+"-"+(row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : row.Sex == 2?'混合':'未知');
			  this.groupItemsData();
			},
 		GetOptionList(){
				let para={State:0}
                  getCompetitionTypeList(para).then((res)=>{
				   this.options=res.data;
				    }).catch(error=>{
				   })					   				   
			},  
		GetGroupList(value){
				let para={CompetitionId:value}
                  getCompetitionGroupList(para).then((res)=>{
				     this.List.forEach(element => {
						 if(element.Id==value)
						 {
							element.CompetitionGroup=res.data;
						 }
					 });
				    }).catch(error=>{
				   })					   				   

		},	
			
		ChangeState(row,index)
			{
				let para={
						id:row.Id,
						state:index				
				}
              ChangeCompetitionState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.CompetitionState=res.data.Data;									
									row.CompetitionGroup.forEach(element => {
										element.state=res.data.ExtendData
									});
                                     this.getListData();       
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},            
						//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : row.Sex == 2?'混合':'未知';
			},
			formatType: function (row, column) {
  				return row.Type == 0 ? '普通组' : row.Type == 1 ? '接力组' : '未知';
                 
			},
            formatEntryDate:function(row,column){
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');

			},
			formatDate: function (row, column) {
				if(column.property=='RegistrationStart')
				{
				return util.formatDate.format(new Date(row.RegistrationStart), 'yyyy-MM-dd');

				}
				if(column.property=='RegistrationEnd')
				{
				return util.formatDate.format(new Date(row.RegistrationEnd), 'yyyy-MM-dd');

				}
				if(column.property=='StartTime')
				{
				return util.formatDate.format(new Date(row.StartTime), 'yyyy-MM-dd');

				}		
				if(column.property=='EndTime')
				{
				return util.formatDate.format(new Date(row.EndTime), 'yyyy-MM-dd');

				}							
			},
			formatState: function (row, column) {
				return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			},
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.getListData();
			},
			handleCurrentChange1(val) {
				this.Peoplepage = val;
				this.getEntry();
			},
			getListData() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					Type:this.filters.Type,
				};
				this.listLoading = true;
				//NProgress.start();
				CompetitionList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
	
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},	
			
			handleItemDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeGroupItem(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.currentGroupRow.ItemCount=res.data.ExtendData;
						this.groupItemsData();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},				
			handleGroupDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeCompetitionGroup(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.GetGroupList(row.CompetitionId);
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},									
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeCompetition(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getListData();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
				// this.editForm.IdentityEnum= String(this.editForm.IdentityEnum);
				// this.editForm.Phone=Number(this.editForm.Phone);
				this.editForm.StartTime= new Date(this.editForm.StartTime);
				this.editForm.EndTime= new Date(this.editForm.EndTime);
				this.editForm.RegistrationStart= new Date(this.editForm.RegistrationStart);
				this.editForm.RegistrationEnd= new Date(this.editForm.RegistrationEnd);

			},
			//显示项目编辑
			handleItemEdit: function (index, row) {
				this.editItemsVisible = true;
				this.editItems = Object.assign({}, row);
				this.GetPostureOption();
			},			
			//显示组编辑界面
			handleGroupEdit( row) {
				console.log("ttt");
				this.editGroupVisible = true;
				this.editGroup = Object.assign({}, row);
				this.currentGroupRow=row;
							},			
			handleGroupAdd(row){
				this.addGroupVisible=true;
                this.addGroup={
					CompetitionId:'',
					CompetitionName:'',
					Type:0,
					Name:'',
					Sex:0,
					AgeMin:0,
					AgeMax:0,
					Remark:'',
					dateValue:''
				}
				this.currentRow=row;
				this.addGroup.CompetitionId=row.Id;
				this.addGroup.CompetitionName=row.Name;
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm= {
					Name: '',
					CompetitionTypeId:'',
					Addres:'',
					RegistrationStart:'',
					RegistrationEnd:'',
					StartTime:'',
					EndTime:'',
					GroupCount:0,
					ContactName:'',
					ContactNumber:'',
				};
				this.addForm.CompetitionTypeId=this.options[0].Id;
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							 if(!(/^1[3456789]\d{9}$/.test(this.editForm.ContactNumber)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }
							this.editLoading = true;
							let para = Object.assign({}, this.editForm);
							editCompetition(para).then((res) => {
								this.editLoading = false;
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
								this.editFormVisible = false;
								this.getListData();
									
								}else
								{
									
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}								
								// this.$refs['editForm'].resetFields();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							 if(!(/^1[3456789]\d{9}$/.test(this.addForm.ContactNumber)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }
							this.addLoading = true;
							let para= Object.assign({}, this.addForm);							
							addCompetition(para).then((res) => {							
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								this.addLoading = false;
								this.addFormVisible = false;

								this.getListData();
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.addLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
			//编辑组
			editGroupSubmit: function () {
				this.$refs.editGroupFrom.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							let para= Object.assign({}, this.editGroup);							
							editCompetitionGroup(para).then((res) => {	
								this.editLoading = false;						
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								
								this.editGroupVisible = false;
                                 this.GetGroupList(this.editGroup.CompetitionId);
								// this.currentGroupRow=res.data.Data;
								console.log(this.currentGroupRow);
								console.log(res.data.Data);
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.editLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},	
			editItemSubmit: function () {
				this.$refs.editItems.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							let para= Object.assign({}, this.editItems);							
							editGroupItem(para).then((res) => {	
								this.editLoading = false;						
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								
								this.editItemsVisible = false;
                                 this.groupItemsData();

								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},				
			//新增项目
			addItemSubmit: function () {
				this.$refs.addItems.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							let para= Object.assign({}, this.addItems);							
							addGroupItem(para).then((res) => {	
								this.addLoading = false;						
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								this.addItemsVisible = false;
								this.currentGroupRow.ItemCount=res.data.ExtendData;
								this.groupItemsTable.push(res.data.Data);
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.addLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},			
			
			
			//新增组
			addGroupSubmit: function () {
				this.$refs.GroupFrom.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							let para= Object.assign({}, this.addGroup);							
							addCompetitionGroup(para).then((res) => {							
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								this.addLoading = false;
								this.addGroupVisible = false;

								this.currentRow.CompetitionGroup.push(res.data.Data);
								this.currentRow.GroupCount=this.currentRow.GroupCount+1;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.addLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},			
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getListData();
			this.GetOptionList();

			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
.customWidth{
        width:22%;
    }
.el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
}
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// Competition.vue?6768dcf0